import React, { useContext, useEffect } from 'react';
import swal from 'sweetalert';

const AuthContext = React.createContext();
export const useAuth = () => useContext(AuthContext);

const AuthProvider = ({ children }) => {
	const [isAuthenticated, setIsAuthenticated] = React.useState(false);
	const [user, setUser] = React.useState(null);

	const logout = () => {
		swal({
			title: "Are you sure you want to logout?",
			icon: "warning",
			buttons: true,
			dangerMode: true,
		})
			.then((confirmation) => {
				if (confirmation) {
					setIsAuthenticated(false);
					setUser(null);
					localStorage.removeItem('user');
				}
			});
	};

	useEffect(() => {
		const user = localStorage.getItem('user');
		if (user) {
			setIsAuthenticated(true);
			setUser(JSON.parse(user));
		}
	}, []);

	return (
		<AuthContext.Provider
			value={{ isAuthenticated, user, setIsAuthenticated, setUser, logout }}>
			{children}
		</AuthContext.Provider>
	);
};

export default AuthProvider;
